export default function StatCard({ icon: Icon, label, value, sub, testid }) {
  return (
    <div data-testid={testid} className="rounded-3xl border border-black/5 bg-white p-6">
      <div className="flex items-center justify-between">
        <span className="text-xs font-semibold uppercase tracking-[0.15em] text-zinc-400">{label}</span>
        {Icon && <Icon className="h-4 w-4 text-zinc-300" />}
      </div>
      <div className="mt-4 truncate font-heading text-3xl font-semibold tracking-tight tabular-nums">{value}</div>
      {sub && <div className="mt-1 text-xs text-zinc-400">{sub}</div>}
    </div>
  );
}
